import React, { useState,useEffect } from "react";

import { getUser,removeUserSession } from "../utils/Common";
import axios from "../utils/axios";
import { toast } from "react-toastify";
import {
  HiBell,
  HiOutlineUserCircle,
  HiOutlineSearch,
  HiOutlineViewList,
} from "react-icons/hi"; // Sidebar icons
import { useNavigate } from "react-router-dom";

const Topbar = ({ setMiniSidebar, isMiniSidebar }) => {
  const navigate = useNavigate(); 
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false); // State to control submenu visibility
  const [isNotifMenuOpen, setNotifMenuOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [modalProfile, setModalProfile] = useState(false);
  const [modalLogout, setModalLogout] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);
  
  const doLogout = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/logout`);
     
      if (response.status === 200) {
         // Update state for room select options
        removeUserSession();
        navigate('/');
        window.location.reload()
      } else {
        throw new Error("Failed to fetch room select options");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error delete token users,cause session data login has been suspend");
      removeUserSession();
      navigate('/');
      window.location.reload()
    } finally {
      setLoading(false);
    }
  };
  
  const toggleAccountMenu = () => {
    setProfileMenuOpen((prevState) => !prevState);
  };

  const toggleNotifMenu = () => {
    setNotifMenuOpen((prevState) => !prevState);
  }

  const openModalAccountSetting =  async (userid) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/user/${userid}`);
      if (response.status === 200) {
        console.log(response.data); // Update state for room select options
        setDataProfile(response.data.data);
        setModalProfile(true)
      } else {
        throw new Error("Failed to fetch room select options");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching room list");
    } finally {
      setLoading(false);
    }
  }

  // Handle file change (preview image before upload)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Set base64 URL for preview
        setDataProfile((prevData) => ({
          ...prevData,
          preview: reader.result,  // Store the base64 string for image preview
        }));

        setDataProfile((prevData) => ({
          ...prevData,
          img_user: file,  // Store the base64 string for image preview
        }));
      };
      reader.readAsDataURL(file); // Convert the selected file to a base64 string
    }
  };

  // Handle form submission (update profile)
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Create FormData to append both text data and the file
    const formData = new FormData();
    formData.append('name', dataProfile.name);
    formData.append('email', dataProfile.email);
    formData.append('phone', dataProfile.phone);
   
    // Check if image is provided and append it
    if (dataProfile.img_user && typeof dataProfile.img_user !== 'string') {
      formData.append('img_user', dataProfile.img_user); // Add the file directly if it's a File object
    } else if (e.target.files && e.target.files[0]) {
      // Check if a file was selected
      formData.append('img_user', e.target.files[0]); // Add the file from the input
    }

    try {
      var id = dataProfile.id;
      // Send data to backend (replace with your API endpoint)
      const response = await axios.post(`/api/update/user/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        // Handle success
        toast.success(response.data.message)
        setModalProfile(false)
      } else {
        toast.info(response.data.message)
        throw new Error('Failed to update profile');
      }
    } catch (err) {
      console.error(err);
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      const userData = getUser(); // Call getUser to fetch user data from localStorage
      if (userData) {
        setUserData(userData); // Store user data in the state if it exists
        // console.log('Users Data Login:',userData)
      } else {
        console.log('Token not found'); // Optionally clear the user data if not found
        navigate('/')
      }
  }, []);
  
  
  return (
    <div>
      {/* Topbar */}
      <header className="flex items-center justify-between px-6 py-5 bg-[#070f23] text-slate-200 shadow-md h-16">
        <div className="flex justify-items-start space-x-1">
          {/* Sidebar Toggle Collapse */}
          <button
            onClick={() => {
              console.log('setMiniSidebar in Topbar:', setMiniSidebar); // Check if function is passed correctly
              setMiniSidebar(!isMiniSidebar);  // Call setMiniSidebar to update state in parent
            }} // Call toggleSidebar to handle both mobile and desktop logic
            className="flex items-center justify-center w-10 h-10 hover:bg-gray-700 rounded-full transition duration-300 md:hidden"
          >
            <HiOutlineViewList size={20} />
          </button>
        </div>

        <div className="flex items-center space-x-4">
          {/* Search Bar */}
          {/* <div className="hidden md:flex items-center bg-gray-100 px-4 py-2 rounded w-80">
            <HiOutlineSearch className="text-gray-500 mr-2" />
            <input
              type="text"
              placeholder="Search..."
              clas
              className="bg-transparent focus:outline-none text-xs"
            />
          </div> */}

          {/* Notifications */}
          <button className="relative" onClick={toggleNotifMenu}>
            <HiBell size={20} />
            <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full px-1 -mx-2 -my-2">
              3
            </span>
            {/* Submenu Dropdown */}
            {isNotifMenuOpen && (
              <div className="absolute flex items-start justify-start right-0 mt-2 w-48 bg-[#101827] text-white rounded-lg shadow-lg">
                <ul className="p-2">
                  <li className="px-4 py-2 text-left hover:bg-gray-700 cursor-pointer" onClick={()=>openModalAccountSetting(userData.id)}>Account</li>
                  <li className="px-4 py-2 text-left  hover:bg-gray-700 cursor-pointer">Logout</li>
                </ul>
              </div>
            )}
          </button>

          {/* Cog Button with Dropdown Menu */}
          <button className="relative" onClick={toggleAccountMenu}>
            <HiOutlineUserCircle size={20} />
            {/* Submenu Dropdown */}
            {isProfileMenuOpen && (
              <div className="absolute flex items-start justify-start right-0 mt-2 w-48 bg-[#101827] text-white rounded-lg shadow-lg">
                <ul className="p-2">
                  <li className="px-4 py-2 text-left text-sm hover:bg-gray-700 cursor-pointer" onClick={()=>openModalAccountSetting(userData.id)}>Account</li>
                  <li className="px-4 py-2 text-left text-sm hover:bg-gray-700 cursor-pointer" onClick={()=>setModalLogout(!modalLogout)}>Logout</li>
                </ul>
              </div>
            )}
          </button>
        </div>
      </header>

      {modalProfile && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-full sm:w-96 md:w-2/3 lg:w-2/3 xl:w-1/4 max-h-screen overflow-y-auto relative">

            {/* Close Button for Mobile */}
            <button onClick={() => setModalProfile(false)} className="absolute top-4 right-4 text-xs bg-gray-400 text-white p-2 rounded-lg hover:bg-gray-700 transition">
              X
            </button>

            {/* Profile Form */}
            <form onSubmit={handleUpdateProfile}>

              {/* Profile Image */}
              <div className="flex justify-center mb-4">
                <img
                  src={dataProfile.preview || dataProfile.img_user} // Default image or uploaded image
                  alt="Profile"
                  className="w-24 h-24 rounded-full border-2 border-white shadow-lg object-cover mt-4"
                />
              </div>

              {/* Image Upload */}
              <div className="mb-4">
                <input
                  type="file"
                  id="img_user"
                  name="img_user"
                  onChange={handleFileChange}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>

              {/* Name Field */}
              <div className="mb-4">
                <label htmlFor="name" className="block text-sm mb-1 font-semibold">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={dataProfile.name}
                  onChange={(e) => setDataProfile({ ...dataProfile, name: e.target.value })}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>

              {/* Email Field */}
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm font-semibold mb-1">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={dataProfile.email}
                  onChange={(e) => setDataProfile({ ...dataProfile, email: e.target.value })}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>

              {/* Phone Field */}
              <div className="mb-4">
                <label htmlFor="phone" className="block text-sm font-semibold mb-1">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={dataProfile.phone}
                  onChange={(e) => setDataProfile({ ...dataProfile, phone: e.target.value })}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>

              {/* Update Profile Button */}
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  onClick={() => setModalProfile(false)}
                  className="px-4 py-2 bg-gray-400 text-white rounded-lg"
                >
                  Cancel
                </button>
                <button
                  className={`px-4 py-2 ${isLoading ? 'bg-gray-500' : 'bg-blue-500'} text-white rounded-lg`}
                  disabled={isLoading}
                >
                  {isLoading ? 'Updating...' : 'Update Profile'}
                </button>
              </div>

            </form>

            {/* Password Update Form */}
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="mb-4 mt-6">
                <label htmlFor="oldpass" className="block text-sm font-semibold mb-1">Old Password</label>
                <input
                  type="password"
                  id="oldpass"
                  name="oldpass"
                  // onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>

              <div className="mb-4">
                <label htmlFor="password" className="block text-sm font-semibold mb-1">New Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  // onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>
              
              <div className="mb-4">
                <label htmlFor="conpass" className="block text-sm font-semibold mb-1">Confirm Password</label>
                <input
                  type="password"
                  id="conpass"
                  name="conpass"
                  // onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>

              {/* Update Authentication Button */}
              <div className="flex justify-between items-center">
                <button
                  // onClick={handleUpdateProfile}
                  className={`px-4 py-2 ${isLoading ? 'bg-gray-500' : 'bg-pink-500'} text-white rounded-lg`}
                  disabled={isLoading}
                >
                  {isLoading ? 'Updating...' : 'Update Authentication'}
                </button>
              </div>
            </form>

          </div>
        </div>
      )}

      {modalLogout && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white text-center p-6 rounded-lg w-full sm:w-96 md:w-2/3 lg:w-2/3 xl:w-1/4 max-h-screen overflow-y-auto relative">

            {/* Close Button for modal */}
            <button onClick={() => setModalLogout(false)} className="absolute top-2 right-4 text-base font-bold  text-black p-2 rounded-lg hover:bg-gray-200 transition">
              X
            </button>

            <div className="mb-4">
              <label htmlFor="name" className="block text-base mb-1 font-semibold">
                Are you sure want to logout ?
              </label>
            </div>

            {/* Update Profile Button */}
            <div className="flex justify-center items-center gap-8">
              <button type="button" onClick={() => setModalLogout(false)} className="px-4 py-2 bg-gray-400 text-white rounded-lg" >
                Cancel
              </button>
              <button className={`px-4 py-2 ${isLoading ? 'bg-gray-500' : 'bg-blue-500'} text-white rounded-lg`} disabled={isLoading} onClick={()=>doLogout()}>
                {isLoading ? 'Logout Process...' : 'Logout'}
              </button>
            </div>





          </div>
        </div>
      )}



    </div>
  );
};

export default Topbar;
